import { ReactNode } from "react"

import { css, cx } from "@emotion/css"

const styles = {
  root: css`
    background-color: var(--lighter-grey);
    color: var(--dark-grey);
    min-height: 288px;
    height: 100%;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 32px 25% 0;
  `,
  noMinHeight: css`
    min-height: auto;
  `,
  icon: css`
    text-align: center;
    color: var(--light-grey);
    width: var(--spacing-xxl-5);
    padding-top: var(--spacing-xs);
    height: var(--spacing-xxl-5);
    margin-bottom: var(--spacing-xs);
  `,
  subtitle: css`
    margin-top: var(--spacing-xs);
    text-align: center;
    display: flex;
  `,
  hide: css`
    height: 18px;
  `,
}

export type EmptyStateProps = {
  title: string
  className?: string
  icon?: ReactNode
  subtitle?: string
  children?: ReactNode
  noMinHeight?: boolean
}

export function EmptyState(props: EmptyStateProps) {
  const { icon, title, subtitle, className, noMinHeight, children } = props
  return (
    <div
      data-testid="list-not-found"
      className={cx(
        styles.root,
        { [styles.noMinHeight]: noMinHeight },
        className,
      )}
    >
      {icon ? <div className={styles.icon}>{icon}</div> : null}
      <h4 className="HeadlineH5Dark-greyRegular">{title}</h4>
      <div className={cx("BodyBody-1Dark-greyLight", styles.subtitle)}>
        {subtitle ? <p>{subtitle}</p> : <div className={styles.hide} />}
      </div>
      {children}
    </div>
  )
}
